(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hindi-heritage-hero"] && !Shopify.designMode) return;
  try {
    
(function(){
  function init(root){
    if(!root || root.dataset.artReady==='true') return;
    root.dataset.artReady='true';
    var options=Array.prototype.slice.call(root.querySelectorAll('[data-art-option]'));
    if(!options.length) return;
    var key='hindi-heritage-art:'+root.id;
    var saved=null;
    try{saved=JSON.parse(sessionStorage.getItem(key)||'null');}catch(e){}
    function eligible(side,exclude){return options.filter(function(el){var pref=el.dataset.side||'either';return el.dataset.artId!==exclude&&(pref==='either'||pref===side);});}
    function pick(side,exclude,wanted){var pool=eligible(side,exclude);if(!pool.length) pool=options.filter(function(el){return el.dataset.artId!==exclude;});if(wanted){var match=pool.find(function(el){return el.dataset.artId===wanted;});if(match)return match;}return pool[Math.floor(Math.random()*pool.length)]||null;}
    var left=pick('left',null,saved&&saved.left);var right=pick('right',left&&left.dataset.artId,saved&&saved.right);
    [['left',left],['right',right]].forEach(function(pair){if(!pair[1])return;var slot=root.querySelector('[data-art-slot="'+pair[0]+'"]');var clone=pair[1].cloneNode(true);clone.hidden=false;clone.removeAttribute('data-art-option');slot.appendChild(clone);});
    if(left||right){try{sessionStorage.setItem(key,JSON.stringify({left:left&&left.dataset.artId,right:right&&right.dataset.artId}));}catch(e){}}
  }
  document.querySelectorAll('[data-hindi-heritage-hero]').forEach(init);
  document.addEventListener('shopify:section:load',function(event){init(event.target.querySelector('[data-hindi-heritage-hero]'));});
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hindi-letter-product"] && !Shopify.designMode) return;
  try {
    
(() => {
  document.querySelectorAll('[data-beenu-side-art]').forEach((image) => {
    const sources = (image.dataset.sources || '').split('|').filter(Boolean);
    if (sources.length < 2) return;
    const storageKey = `beenu-side-art-${image.dataset.side || 'panel'}`;
    let previousIndex = -1;
    try { previousIndex = Number.parseInt(sessionStorage.getItem(storageKey), 10); } catch (error) { previousIndex = -1; }
    let nextIndex = Math.floor(Math.random() * sources.length);
    if (Number.isInteger(previousIndex) && nextIndex === previousIndex) nextIndex = (nextIndex + 1) % sources.length;
    image.src = sources[nextIndex];
    try { sessionStorage.setItem(storageKey, String(nextIndex)); } catch (error) {}
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
